<template>
    <a 
        class="hero-card" 
        :style="{ backgroundImage: `url(${item.image})` }" 
        :href="item.link"
    >
        <h3 class="title" v-html="item.title"></h3>
        <div class="title-container">
            <p class="description"  v-html="item.description"></p>
            
            <RenaultButton  is-anchor is-small is-white :href="item.link">
                <svg class="icon">
                    <use xlink:href="#icon-arrow-right1"></use>
                </svg>

            </RenaultButton>
        </div>
    </a>
</template>

<script>
import RenaultButton from '../Shared/RenaultButton.vue';
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    components: {
        RenaultButton,
    },
};
</script>
